import { useEffect, useState } from 'react'
import Select from 'react-select'
import { startSxpProxy } from '../../utils/api'
import { LABS_PROJECT_ID } from '../../utils/constants'
import { Package } from '../lms/models'
import { Panel } from './models'
import { API_INTENTS } from '../lms/components/admin/constants'
import { active } from '../AB Membership/constants'
import { orderStatus } from '../lms/constants'
import './OPDOrders.css'
type Props = {
  id: number
  status: string
  onTestSelect?: (payload: {
    packageId: number
    productName: string
    packagePrice: number
    OdooPackageId: any
    panels: Panel[]
  }) => void
  onChange?: (selectedPkg: {
    value: number
    label: string
    price?: number
    OdooPackageId?: any
  }) => void
}

const PackageTests = ({ id, status, onTestSelect, onChange }: Props) => {
  const [packages, setPackages] = useState<Package[]>([])
  const [selectedPackage, setSelectedPackage] = useState<{
    value: number
    label: string
    price?: number
  } | null>(null)

  useEffect(() => {
    startSxpProxy(LABS_PROJECT_ID, API_INTENTS?.PACKAGES, {})
      ?.then((data: any) => {
        const allPackages: Package[] = data?.data?.packages ?? []
        const activePackages = allPackages?.filter(
          (pkg) =>
            pkg?.status === active &&
            (!pkg?.active_till ||
              new Date(pkg?.active_till).getTime() >= Date.now())
        )
        setPackages(activePackages)
        if (id) {
          const pkg = activePackages?.find((p) => p?.id === id)
          if (pkg) {
            setSelectedPackage({
              value: pkg?.id,
              label: pkg?.name,
              price: pkg?.price,
            })
          }
        }
      })
      .catch((err) => console.error(err))
  }, [id])

  const handlePackageChange = (option: any) => {
    if (status && status !== orderStatus?.ordered) return
    const pkg = packages?.find((p) => p?.id === option?.value)
    if (!pkg) return
    const odooPackageId =
      pkg?.package_id ?? pkg?.odoo_test_id ?? pkg?.odooPackageId ?? null
    setSelectedPackage(option)
    const panels: Panel[] = (pkg?.panels ?? [])?.map((panel: any) => ({
      id: panel?.id,
      name: panel?.name ?? '',
      description: panel?.description ?? '',
      price: panel?.price ?? 0,
      lab_tests: panel?.lab_tests ?? [],
      sampleId: panel?.sampleId ?? null,
      sampleName: panel?.sampleName ?? '',
      processing_unit: panel?.processing_unit ?? '',
      active: panel?.active ?? true,
    }))
    onTestSelect?.({
      packageId: pkg?.id,
      productName: pkg?.name,
      packagePrice: pkg?.price ?? 0,
      OdooPackageId: odooPackageId,
      panels,
    })
    onChange?.({
      ...option,
      OdooPackageId: odooPackageId,
    })
  }

  const packageOptions = packages?.map((pkg) => ({
    value: pkg?.id,
    label: pkg?.name,
    price: pkg?.price,
  }))

  return (
    <Select
      options={packageOptions}
      value={selectedPackage}
      onChange={handlePackageChange}
      placeholder='Select a Package'
      menuPortalTarget={document.body}
      menuPosition='fixed'
      classNames={{
        menuPortal: () => 'custom-select-portal',
        menu: () => 'custom-select-menu',
        menuList: () => 'custom-select-menu-list',
        option: () => 'custom-select-option',
        singleValue: () => 'custom-select-single-value',
      }}
    />
  )
}

export default PackageTests
